import { LIFERAY_HOST } from "./utils";

const headers = {
    "Content-Type": "application/json",
    ...(window?.Liferay?.authToken && ({"x-csrf-token": window.Liferay.authToken})),
    credentials: "include",
} 

const postFileHeaders = {
  ...(window?.Liferay?.authToken && ({"x-csrf-token": window.Liferay.authToken})),
  Accept: "application/json",
};

const LiferayService = {
  get: (url, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: headers,
          method: "GET",
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  post: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: headers,
          method: "POST",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  postFile: (url, formData) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: postFileHeaders,
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  put: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: headers,
          method: "PUT",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  patch: (url, payload, options = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: headers,
          method: "PATCH",
          body: JSON.stringify(payload),
          ...options,
        });
        const data = await response.json();
        if (response.ok) {
          resolve(data);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
  delete: (url) => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(LIFERAY_HOST + "/" + url, {
          headers: headers,
          method: "DELETE",
        });

        if (response.ok) {
          resolve(true);
        } else {
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    });
  },
};

export default LiferayService;
